import JwtService from "@/core/services/JwtService";
import axios, { AxiosResponse } from "axios";
import { App } from "vue";
import VueAxios from "vue-axios";
import store from "@/store";
import { Actions } from "@/store/enums/StoreEnums";
class ApiService {
  // Picked from the host serving the app, so one build works live and locally.
  // Vue CLI only exposes VUE_APP_* variables to the browser; set
  // VUE_APP_API_URL (including "/api") in .env to point anywhere else.
  public static API_URL =
    process.env.VUE_APP_API_URL ||
    (window.location.hostname.endsWith("sicip.gov.bd")
      ? "https://bee.sicip.gov.bd/api"
      : "http://localhost:8000/api");
  public static vueInstance: App;
  public static init(app: App<Element>) {
    ApiService.vueInstance = app;
    ApiService.vueInstance.use(VueAxios, axios);
    //ApiService.vueInstance.axios.defaults.baseURL = process.env.API_URL ?;
  }

  public static setHeader(): void {
    ApiService.vueInstance.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;
  }

  /**
   * A request that failed. With a reply from the server the reply is returned as before
   * (logging out on 401). Without one (server not running or unreachable, request cut off by a
   * timeout or gateway, or blocked by CORS) there is nothing to return, and reading
   * error.response.status used to fail with "Cannot read properties of undefined (reading
   * 'status')"; throw a message people can act on instead.
   */
  private static failed(error: any): AxiosResponse {
    if (!error?.response) {
      throw new Error(
        "No response from the TMS server. Please check your connection and try again. " +
          "If it keeps happening, the server may be down or the request took too long."
      );
    }
    if (error.response.status == 401) {
      store.dispatch(Actions.LOGOUT);
    }
    return error.response;
  }

  public static async get(slug = "" as string): Promise<AxiosResponse> {
    try {
      ApiService.setHeader();
      const response = await ApiService.vueInstance.axios.get(
        `${ApiService.API_URL}/${slug}`
      );
      return response;
    } catch (error: any) {
      return ApiService.failed(error);
    }
  }

  public static async post(
    slug: string,
    params: unknown
  ): Promise<AxiosResponse> {
    try {
      const response = await ApiService.vueInstance.axios.post(
        `${ApiService.API_URL}/${slug}`,
        params
      );
      return response;
    } catch (error: any) {
      return ApiService.failed(error);
    }
  }

  public static async update(
    slug: string,
    params: unknown
  ): Promise<AxiosResponse> {
    try {
      const response = await ApiService.vueInstance.axios.put(
        `${ApiService.API_URL}/${slug}`,
        params
      );
      return response;
    } catch (error: any) {
      return ApiService.failed(error);
    }
  }

  public static async delete(slug: string): Promise<AxiosResponse> {
    try {
      const response = await ApiService.vueInstance.axios.delete(
        `${ApiService.API_URL}/${slug}`
      );
      return response;
    } catch (error: any) {
      return ApiService.failed(error);
    }
  }
}

export default ApiService;
